import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/tasksApi';
import * as types from '../constants/tasksConstants';

export const getTasksActions = (search, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_TASKS_REQUEST });
  try {
    const { error, data } = await api.getTasks(search, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_TASKS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список послуг');
    dispatch({ type: types.GET_TASKS_FAILURE });
  }
};

export const updateTaskAction = (task) => async () => {
  try {
    const { error } = await api.updateTask(task);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити послугу');
  }
};

export const createTaskAction = (task) => async () => {
  try {
    const { error } = await api.createTask(task);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати послугу');
  }
};

export const deleteTaskAction = (taskId) => async () => {
  try {
    const { error } = await api.deleteTask(taskId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити послугу');
  }
};

export const clearTasksAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_TASKS,
  });
};

export const setTasksPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_TASKS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedTaskAction = (task) => async (dispatch) => {
  dispatch({
    type: types.SELECT_TASK,
    payload: task,
  });
};

export const clearSelectedTaskAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_TASK,
  });
};

export const setTasksSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_TASKS_SEARCH,
    payload: search,
  });
};

export const nextTasksPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_TASKS_PAGE,
  });
};

export const prevTasksPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_TASKS_PAGE,
  });
};
